<template>
  <div>
    <div ref="form">
      <!-- Row Loop -->
      <b-row
        v-for="(cantidad, index) in cantidades"
        :id="index"
        :key="index"
        ref="row"
      >
        <!-- Item Name -->
        <b-col cols="10">
          <CantidadTransporta :cantidad="cantidad" :index="index" />
        </b-col>

        <!-- Remove Button -->
        <b-col cols="2">
          <b-button
            v-ripple.400="'rgba(234, 84, 85, 0.15)'"
            variant="outline-danger"
            class="mt-0 mt-md-2"
            @click="removeItem(index)"
          >
            <feather-icon icon="XIcon" class="mr-25" />
            <span>Borrar</span>
          </b-button>
        </b-col>
        <b-col cols="12">
          <hr />
        </b-col>
      </b-row>

      <b-button
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        variant="secondary"
        @click="addItem"
      >
        <feather-icon icon="PlusIcon" class="mr-25" />
        <span>Agregar punto de distribución o captación</span>
      </b-button>
    </div>
  </div>
</template>

<script>
import { BRow, BCol, BButton } from 'bootstrap-vue'
import { heightTransition } from '@core/mixins/ui/transition'
import Ripple from 'vue-ripple-directive'
import CantidadTransporta from '@/views/CartaPorte/CantidadTransporta'

export default {
  components: {
    CantidadTransporta,
    BRow,
    BCol,
    BButton,
  },
  directives: {
    Ripple,
  },
  mixins: [heightTransition],
  props: {
    cantidades: {
      type: Array,
      default: null,
    },
  },
  data() {
    return {
      nextRowId: 0,
    }
  },
  computed: {},
  mounted() {
    this.initTrHeight()
    this.nextRowId = this.cantidades.length
  },
  created() {
    window.addEventListener('resize', this.initTrHeight)
  },
  destroyed() {
    window.removeEventListener('resize', this.initTrHeight)
  },
  methods: {
    addItem() {
      this.cantidades.push({
        '@Cantidad': '',
        '@IDOrigen': '',
        '@IDDestino': '',
      })

      this.$nextTick(() => {
        this.trAddHeight(this.$refs.row[0].offsetHeight)
      })
    },
    removeItem(index) {
      this.cantidades.splice(index, 1)
      this.trTrimHeight(this.$refs.row[0].offsetHeight)
    },
    initTrHeight() {
      this.trSetHeight(null)
      this.$nextTick(() => {
        this.trSetHeight(this.$refs.form.scrollHeight)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.repeater-form {
  overflow: hidden;
  transition: 0.35s height;
}
</style>

<style lang="scss">
@import 'src/@core/scss/vue/libs/vue-select.scss';
</style>
